export default __webpack_public_path__ + "static/media/Logo_Final_Super6Millonario.e3bde702.png";